<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <route-period-edit-form
        @on-submit="onRoutePeriodEditSubmit"
      ></route-period-edit-form>
    </div>
  </div>
</template>
<script>
import RoutePeriodEditForm from "./RoutePeriodEditForm.vue";

export default {
  components: {
    RoutePeriodEditForm: RoutePeriodEditForm
  },
  data() {
    return {
      routePeriodEditModel: {}
    };
  },
  methods: {
    onRoutePeriodEditSubmit(model) {
      this.routePeriodEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'routes/' + this.routePeriodEditModel.id, Object.assign(this.routePeriodEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
